// Splits a tooltip body into plain-text runs and bracketed formula/example segments (spec 4.5).
// Each LINE inside a bracket is split independently on its own first colon (colon kept in the
// plain half, matching spec's own "Plain text: ... `: `" reading) -- a line with no colon is bold
// in full. See README.md ("tooltip formula pills") for why per-line, not per-bracket.
const BRACKET_RE = /\[([^\]]*)\]/g

function splitLine(line) {
  const colonIndex = line.indexOf(':')
  return colonIndex === -1 ? { bold: line, plain: '' } : { bold: line.slice(0, colonIndex), plain: line.slice(colonIndex) }
}

export function parseTooltipSegments(text) {
  if (!text) return []
  const segments = []
  let lastIndex = 0
  let match
  while ((match = BRACKET_RE.exec(text)) !== null) {
    if (match.index > lastIndex) segments.push({ type: 'text', content: text.slice(lastIndex, match.index) })
    segments.push({ type: 'pill', lines: match[1].split('\n').map(splitLine) })
    lastIndex = BRACKET_RE.lastIndex
  }
  if (lastIndex < text.length) segments.push({ type: 'text', content: text.slice(lastIndex) })
  return segments
}

// Letter 99 (7.3.2): the gap between text and a pill is the pill's own 16px margin, so the line breaks
// the copy carries next to a bracket are dropped (they used to add a blank 20px line). Text left empty
// by that (a bare "\n" between two pills) is dropped too.
export function trimAroundPills(segments) {
  return segments
    .map((segment, i) => {
      if (segment.type !== 'text') return segment
      let content = segment.content
      if (segments[i - 1]?.type === 'pill') content = content.replace(/^\n+/, '')
      if (segments[i + 1]?.type === 'pill') content = content.replace(/\n+$/, '')
      return { ...segment, content }
    })
    .filter((segment) => segment.type !== 'text' || segment.content !== '')
}

// Letter 99 (7.3.5): bold words in the running text (outside the pills), marked in the copy as
// `**word**` -- the words the canvas notes "Tool tips 1/2" / "Tool tips 2/2" set in bold. Only a
// closed pair on one line counts; a stray or unclosed `**` stays literal text. Returns runs of
// { text, bold }; the caller renders them as React text, so nothing is parsed as HTML.
// `**` markers are for running text only: never inside [pills], which keep splitLine's own bold rule.
const BOLD_RE = /\*\*([^*\n]+?)\*\*/g

export function parseBoldRuns(text) {
  if (!text) return []
  const runs = []
  let lastIndex = 0
  let match
  BOLD_RE.lastIndex = 0
  while ((match = BOLD_RE.exec(text)) !== null) {
    if (match.index > lastIndex) runs.push({ text: text.slice(lastIndex, match.index), bold: false })
    runs.push({ text: match[1], bold: true })
    lastIndex = BOLD_RE.lastIndex
  }
  if (lastIndex < text.length) runs.push({ text: text.slice(lastIndex), bold: false })
  return runs
}
